import H3 from '@base/H3/H3';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

const Empty = styled.div`
  grid-column: 11/16;
  text-align: center;
  margin-top: ${Spacings.SPACING_24B};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NoPractices = styled(H3)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
`;

const StyledP1 = styled(P1)`
  width: 198px;
`;

const EmptyState = () => {
  return (
    <Empty>
      <Image
        src="/educator/auto-dpp/girl-with-magnifying-glass.svg"
        width="80"
        height="80"
        alt="girl with magnifying glass"
      />
      <NoPractices>No practices found</NoPractices>
      <StyledP1 color="var(--color-text-secondary)">
        Try changing filters to see more practices
      </StyledP1>
    </Empty>
  );
};

export default EmptyState;
